import { MenuItem, Tooltip, type MenuItemProps } from '@mui/material';

interface Props extends MenuItemProps {
  isUsable: boolean;
  isExpectedUsable: boolean;
  unusableExplanation: string | null | undefined;
}

export const MaybeUsableMenuItem = ({
  isUsable,
  isExpectedUsable,
  unusableExplanation,
  ...menuItemProps
}: Props) => {
  if (isUsable) {
    return <MenuItem {...menuItemProps} />;
  }

  // If there's an explanation and the option isn't usable, but may be expected to be usable
  // then grey it out and explain why it's not usable
  if (unusableExplanation && !isUsable && isExpectedUsable) {
    return (
      <Tooltip title={unusableExplanation}>
        <span>
          <MenuItem {...menuItemProps} disabled />
        </span>
      </Tooltip>
    );
  }

  return null;
};
